import { Rocket } from "components/icons/generated";
import LinkButton from "ds/components/Button/LinkButton";
import ActionCard from "ds/components/ActionCard";
import { AnalyticsPageDashboard } from "hooks/useAnalytics/pages/dashboard";

const DashboardOverviewColumnTestPilot = () => {
  return (
    <ActionCard
      title="Spacelift TestPilot program"
      icon={Rocket}
      iconColor="yellow"
      description="Help us tailor Spacelift to your needs by joining our testing program!"
      actionComponent={
        <LinkButton
          variant="secondary"
          size="medium"
          target="_blank"
          rel="noopener noreferrer"
          href="https://spacelift.io/join-test-pilot-program"
          analyticsPage={AnalyticsPageDashboard.Dashboard}
          analyticsTitle="Dashboard - Test Pilot Clicked"
        >
          Sign up
        </LinkButton>
      }
    />
  );
};

export default DashboardOverviewColumnTestPilot;
